// @flow
import React, { useEffect, useState } from 'react';
import { EventTicketStatus } from 'Mock/eventTicketStatus';
import DotSeparator from 'components/atoms/dotSeparator';
import tableForTwo from 'assets/images/Ticketing-Table-for-2-B.svg';
import tableForTwoCorner from 'assets/images/Ticketing-Table-for-2-A.svg';
import tableForThree from 'assets/images/Ticketing-Table-for-3.svg';
import tableForFour from 'assets/images/Ticketing-Table-for-4.svg';
import tableForFive from 'assets/images/Ticketing-Table-for-5.svg';
import tableForSix from 'assets/images/Ticketing-Table-for-6.svg';
import tableForSeven from 'assets/images/Ticketing-Table-for-7-8.svg';
import tableForEight from 'assets/images/Ticketing-Table-for-7-8.svg';
//eslint-disable-next-line
import styles from "./styles.scss";
type Props = {};

const areEqual = (prevProps, nextProps) => {
  return prevProps.eventDate === nextProps.eventDate
    ? prevProps.personCount === nextProps.personCount
      ? true
      : false
    : false;
};

const EventTicketGrid = React.memo((props: Props) => {
  const { personCount, tableSelected, gridLayout, eventDate } = props;
  const [tableClick, setTableClick] = useState(false);

  useEffect(() => {
    let parent_div = document.getElementsByClassName(
      'ticket-grid-container'
    )[0];
    // to disable all the tables in the grid.
    let table_attributes = parent_div.getElementsByClassName('table-image');
    toggleTableClass('add', table_attributes, 'disabled');
    switch (personCount) {
      case 2:
        //if user selects person-count as 2, then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-2'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-4'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('corner-table-1'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('corner-table-2'),
          'disabled'
        );
        break;
      case 3:
        //if user selects person-count as 3, then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-1'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-5'),
          'disabled'
        );
        break;
      case 4:
      case 5:
      case 6:
        //if user selects person-count as (4,5,6), then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-1'),
          'disabled'
        );
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-5'),
          'disabled'
        );
        break;
      case 7:
      case 8:
        //if user selects person-count as (7,8), then enable the respective tables.
        toggleTableClass(
          'remove',
          parent_div.getElementsByClassName('table-3'),
          'disabled'
        );
        break;
    }
  }, [personCount, tableClick]);

  useEffect(() => {
    let parent_div = document.getElementsByClassName(
      'ticket-grid-container'
    )[0];
    // to disable all the tables in the grid.
    let table_attributes = parent_div.getElementsByClassName('table-image');
    toggleTableClass('add', table_attributes, 'disabled');
  }, [eventDate]);

  const toggleTableClass = (type, attribute, className) => {
    // To add/remove a class from list of elements.
    for (let i = 0; i < attribute.length; i++) {
      if (type === 'remove') attribute[i].classList.remove(className);
      if (type === 'add') attribute[i].classList.add(className);
    }
  };
  const image_side_table =
    personCount === 4
      ? tableForFour
      : personCount === 5
      ? tableForFive
      : personCount === 6
      ? tableForSix
      : tableForThree;
  const image_centre_table = personCount === 7 ? tableForSeven : tableForEight;
  const outletTableCol = (col_name, tables) => (
    <div className={col_name}>
      {personCount === 4 || personCount === 5 || personCount === 6
        ? tableDiagram(
            tables[0],
            image_side_table,
            'joined-tables',
            [tables[0].id, tables[1].id],
            tables[0].booked || tables[1].booked
          )
        : tableDiagram(
            tables[0],
            image_side_table,
            '',
            [tables[0].id],
            tables[0].booked
          )}
      {personCount === 4 || personCount === 5 || personCount === 6
        ? null
        : tableDiagram(
            tables[1],
            tableForTwo,
            '',
            [tables[1].id],
            tables[1].booked
          )}
      {tableDiagram(
        tables[2],
        image_centre_table,
        '',
        [tables[2].id],
        tables[2].booked
      )}
      {personCount === 4 || personCount === 5 || personCount === 6
        ? null
        : tableDiagram(
            tables[3],
            tableForTwo,
            '',
            [tables[3].id],
            tables[3].booked
          )}
      {personCount === 4 || personCount === 5 || personCount === 6
        ? tableDiagram(
            tables[4],
            image_side_table,
            'joined-tables',
            [tables[3].id, tables[4].id],
            tables[3].booked || tables[4].booked
          )
        : tableDiagram(
            tables[4],
            image_side_table,
            '',
            [tables[4].id],
            tables[4].booked
          )}
    </div>
  );
  const tableDiagram = (table, image, className, tableIds, isBooked) => {
    //Used to form a Table Diagram and put all details of the respective tables.
    return (
      <img
        id={table.id}
        className={`${table.className} ${className} ${
          isBooked ? 'reserved' : ''
        }${table.imageSelected ? 'selected' : ''}`}
        src={image}
        alt={'table'}
        style={{ height: '50px', width: '50px', cursor: 'pointer' }}
        onClick={() => onTableDiagramClick(table, tableIds)}
      />
    );
  };
  const onTableDiagramClick = (tableData, tableIds) => {
    //Action triggered when user clicks on a table image,
    //Used to toggle the imageSelected boolean value from the data.
    tableData.imageSelected = !tableData.imageSelected;
    toggleTableStatus(gridLayout.firstRow, tableData);
    toggleTableStatus(gridLayout.secondRow, tableData);
    toggleTableStatus(gridLayout.thirdRow, tableData);
    toggleTableStatus(gridLayout.fourthRow, tableData);
    toggleTableStatus(gridLayout.fifthRow, tableData);
    toggleTableStatus(gridLayout.cornerRow, tableData);
    tableData.imageSelected ? tableSelected(tableIds) : tableSelected([]);
    setTableClick(!tableClick);
  };
  const toggleTableStatus = (rowData, specificTable) => {
    for (let i = 0; i < rowData.length; i++) {
      if (rowData[i].id !== specificTable.id) rowData[i].imageSelected = false;
    }
  };
  return (
    <div className={'ticket-grid-container'}>
      <div className={'stage'}>
        <h3>STAGE</h3>
      </div>
      <div className={'status-types'}>
        {EventTicketStatus.map((status, idx) => (
          <div className={` ${status.className} ticket-status`}>
            <DotSeparator />
            <span>{status.label}</span>
          </div>
        ))}
      </div>
      {tableDiagram(
        gridLayout.cornerRow[0],
        tableForTwoCorner,
        '',
        [gridLayout.cornerRow[0].id],
        gridLayout.cornerRow[0].booked
      )}
      {tableDiagram(
        gridLayout.cornerRow[1],
        tableForTwoCorner,
        '',
        [gridLayout.cornerRow[1].id],
        gridLayout.cornerRow[1].booked
      )}
      {outletTableCol('table-col-1', gridLayout.firstRow)}
      {outletTableCol('table-col-2', gridLayout.secondRow)}
      {outletTableCol('table-col-3', gridLayout.thirdRow)}
      {outletTableCol('table-col-4', gridLayout.fourthRow)}
      {outletTableCol('table-col-5', gridLayout.fifthRow)}
    </div>
  );
}, areEqual);
export default EventTicketGrid;
